import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlagiarism = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25402",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25402)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.38146 13.7178C9.64215 13.7178 9.89535 13.6812 10.141 13.608C10.3867 13.5348 10.6165 13.4304 10.8302 13.2947L12.984 15.4487L13.8621 14.5703L11.7083 12.4166C11.8547 12.2083 11.9618 11.9798 12.0296 11.7314C12.0975 11.483 12.1315 11.2285 12.1315 10.9678C12.1315 10.221 11.8681 9.58992 11.3412 9.0745C10.8146 8.55895 10.1752 8.30117 9.42313 8.30117C8.6709 8.30117 8.03146 8.5645 7.50479 9.09117C6.97813 9.61797 6.71479 10.2574 6.71479 11.0095C6.71479 11.7616 6.9725 12.401 7.48792 12.9278C8.00347 13.4545 8.63465 13.7178 9.38146 13.7178ZM9.42313 12.4678C9.02243 12.4678 8.67917 12.3249 8.39333 12.0391C8.10764 11.7534 7.96479 11.4102 7.96479 11.0095C7.96479 10.6088 8.10764 10.2656 8.39333 9.97992C8.67917 9.69409 9.02243 9.55117 9.42313 9.55117C9.82368 9.55117 10.1669 9.69409 10.4527 9.97992C10.7385 10.2656 10.8815 10.6088 10.8815 11.0095C10.8815 11.4102 10.7385 11.7534 10.4527 12.0391C10.1669 12.3249 9.82368 12.4678 9.42313 12.4678ZM5.25646 17.9166C4.83549 17.9166 4.47917 17.7708 4.1875 17.4791C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58971C3.75 3.16874 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83549 2.08325 5.25646 2.08325H11.875L16.25 6.45825V16.4101C16.25 16.8311 16.1042 17.1874 15.8125 17.4791C15.5208 17.7708 15.1645 17.9166 14.7435 17.9166H5.25646ZM11.25 7.08325V3.33325H5.25646C5.19229 3.33325 5.13354 3.35999 5.08021 3.41346C5.02674 3.46679 5 3.52554 5 3.58971V16.4101C5 16.4743 5.02674 16.533 5.08021 16.5864C5.13354 16.6398 5.19229 16.6666 5.25646 16.6666H14.7435C14.8077 16.6666 14.8665 16.6398 14.9198 16.5864C14.9733 16.533 15 16.4743 15 16.4101V7.08325H11.25Z",
			fill: "#064C68"
		})
	})]
});
export default SvgPlagiarism;
